<template>
  <div>

<b-navbar toggleable="lg" type="dark" class="custom-nav-card custom-nav-menu">
    <b-navbar-brand href="#">
       <b-img src="./img/site/logo4.png" fluid height="50" width="140"></b-img>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
          <b-nav-item align="center" class="custom-nav-item-menu" v-on:click="makeResize()">Despre |</b-nav-item>
          <b-nav-item align="center" class="custom-nav-item-menu" v-on:click="makecolapse4()">Motivation |</b-nav-item>        
          <b-nav-item align="center" class="custom-nav-item-menu" v-on:click="makecolapse2()">Contact |</b-nav-item>
          <b-nav-item align="center" class="custom-nav-item-menu-promo" href="https://play.google.com/store/apps/details?id=org.motivation.accesibil">Android<b-icon icon="cloud-download" animation="throb"/></b-nav-item>
          <b-nav-item align="center" class="custom-nav-item-menu-promo3" href="https://apps.apple.com/ro/app/harta-accesibilitatii/id1099761871">iOS<b-icon icon="cloud-download" animation="throb"/></b-nav-item>
      </b-navbar-nav>
      
      <b-navbar-nav class="ml-auto">
          <b-nav-item class="custom-nav-item-menu-promo2" href="https://play.google.com/store/apps/developer?id=Fundatia+Motivation+Romania" target="_blank">Aplicatiile Motivation</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>


    <!-- <b-card title="Search bar" no-body class="custom-nav-card" id="searchnavbar">
      <b-card-header header-tag="nav" class="custom-nav-menu">
        <b-nav card-header pills align="center">
          <b-nav-form @submit.stop.prevent>
            <b-form-input v-model="searchkeyword" size="sm" class="mr-sm-2" placeholder="Cauta" ></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit" variant="outline-secondary"><b-icon icon="search"></b-icon></b-button>
          </b-nav-form>
        </b-nav>
      </b-card-header>
    </b-card> -->



    <b-collapse v-bind:visible="visible2" id="collapse-2" ref="collapse-2">
      <div class="container-xl custom-contact-container">
        <div class="row">
          <div class="col col-xl-12 ">
            <b-button aria-label="Close" class="close text-dark" v-b-toggle.collapse-2><b-icon icon="x" font-scale="1"></b-icon></b-button>            
          </div>
        </div>
        <div class="row">
          <div class="col col-xl-8 ">
            <b-card>
              <p>
                <strong>Pentru detalii privind evaluarea accesibilității instituției dumneavoastră</strong>, vă invităm să completati formularul.
              </p>
              <p>Pentru informații despre serviciile oferite de Motivation utilizatorilor de scaune rulante, apelati Telefonul utilizatorului de scaun rulant.</p>
              <p>
                <span class="custom-font-motivation-green">0800.030.762</span> este un serviciu telefonic gratuit de informare și consiliere adresat persoanelor cu dizabilități locomotorii, care au dreptul la un scaun rulant adaptat și specific nevoilor lor. Acest numar poate fi apelat fără taxă din rețelele Romtelecom, UPC-Vodafone, Orange și Cosmote, de luni până vineri, între orele 9:00 și 16:00.
              </p>
            </b-card>
            <b-card class="container-fluid">
              <div class="row">
                <div class="col col-sm-8 custom-contact-branding">
                  <p>
                    <strong>Fundația Motivation România</strong>
                  </p>
                  Adresa: Str. Podișor Nr.1, loc. Buda, Com Cornetu, Jud Ilfov , România
                  <p>Fax: +4021 448.11.07</p>
                  <p>
                    Telefon:
                    <b-link href="tel:+40314230370">031.423.03.70</b-link>
                  </p>
                  <p>
                    <b-link href="mailto:accesibil@motivation.ro">accesibil@motivation.ro</b-link>
                  </p>
                  <p>
                    <b-link href="https://motivation.ro" variant="primary">www.motivation.ro</b-link>
                  </p>
                </div>
                <div class="col col-sm-4">
                  <br />
                  <br />
                  <br />
                  <b-img fluid src="./img/site/motivation.png"></b-img>
                </div>
              </div>
            </b-card>

          </div>
          <div class="col-xl-4">
            <ContactForm v-bind:title="'Contacteaza-ne!'"> </ContactForm>
          </div>
        </div>
      </div>
    </b-collapse>

    <b-collapse v-bind:visible="visible3" id="collapse-3" ref="collapse-3">
      <div class="container-xl custom-despre-container ">
        <div class="row ">
          <div class="col col-xl-12">
            <b-button aria-label="Close" class="close text-dark" v-b-toggle.collapse-3><b-icon icon="x" font-scale="1"></b-icon></b-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <p><strong>Harta accesibilității</strong></p>
                <p >Harta accesibilității este un instrument dedicat persoanelor în scaun rulant, o sursă de informații utile care centralizează date despre spațiile accesibile în România.</p>
                <!-- <p>Serviciile oferite de <strong class="custom-font-motivation-blue">Motivation</strong>  în prezent sunt integrate în proiectul Roțile Schimbării finanțat de <strong >USAID - Agenția Statelor Unite pentru Dezvoltare Internațională</strong> , în perioada 2009 - 2014.</p> -->
                <p><strong class="custom-font-motivation-green">Marca Accesibilității Motivation</strong>  este înregistrată la Oficiul de Stat pentru Invenții și Mărci având numărul de depozit <strong>M2012 02770</strong> </p>
                <!-- <p>Accesibilitatea spațiilor este o condiție esențială pentru participarea utilizatorilor de scaune rulante. Ea este prevăzută ca obligație legală pentru administratorii clădirilor. Cu toate acestea, în realitate, persoanele cu dizabilități locomotorii din România se confruntă adesea cu bariere legate de accesul în clădiri. La fel ca orice altă persoană, un utilizator de scaun rulant este interesat de spații de cazare, atunci când planifică o vacanță sau călătorește în interes de serviciu, de accesul în muzee și alte spații culturale, precum și de spații comerciale, unde ar putea să-și facă cumpărăturile.</p> -->
              </div>                
            </div>
            <div class="card">
              <div class="card-body">
                  <p>Accesibilitatea spațiilor este o condiție esențială pentru participarea utilizatorilor de scaune rulante. Ea este prevăzută ca obligație legală pentru administratorii clădirilor. Cu toate acestea, în realitate, persoanele cu dizabilități locomotorii din România se confruntă adesea cu bariere legate de accesul în clădiri. La fel ca orice altă persoană, un utilizator de scaun rulant este interesat de spații de cazare, atunci când planifică o vacanță sau călătorește în interes de serviciu, de accesul în muzee și alte spații culturale, precum și de spații comerciale, unde ar putea să-și facă cumpărăturile.</p>
              </div>              
            </div>            
          </div>
          <div class="col-xl-6">
            <div class="card-body">
              <HartaEchipe v-bind:apiresourceurl="apiresourceurl"/>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>

    <b-collapse v-bind:visible="visible4" id="collapse-4" ref="collapse-4">
      <div class="container-xl custom-motivation-container">
        <div class="row">
          <div class="col col-xl-12">
            <b-button aria-label="Close" class="close text-dark" v-b-toggle.collapse-4><b-icon icon="x" font-scale="1"></b-icon></b-button>            
          </div>
        </div>
        <div class="row">
          <div class="col-xl-8">
            <div class="card">
              <p><strong class="custom-font-motivation-blue">Fundația Motivation România</strong> este o organizație neguvernamentală, nonprofit, care există din 1995 pentru a veni în sprijinul persoanelor cu dizabilități din România.</p>
              <p>Ne-am asumat misiunea de a-i ajuta pe utilizatorii de scaun rulant să atingă un nivel maxim de independență, să se integreze social și profesional. Peste <strong class="custom-font-motivation-blue">25800</strong> de persoane și-au recăpătat mobilitatea și speranța într-o viață mai bună cu ajutorul Motivation</p>
              <p>Beneficiarii noștri primesc servicii de evaluare și prescriere de echipamente de mobilitate, participă la tabere de recuperare activă și instruire pentru viață independentă, sunt implicați în evenimente sportive în scaun rulant și se bucură de sprijin în integrarea pe piața muncii.</p>              
            </div>
          </div>
          <div class="col-xl-4">
                <div>
                  <b-carousel
                    id="carousel-fade"
                    style="text-shadow: 0px 0px 2px #000"
                    fade
                    indicators
                    :interval="4000"
                    img-width="1024"
                    img-height="480"
                  >
                    <b-carousel-slide
                      img-src="./img/misc/slider-SMS.jpg"
                    ></b-carousel-slide>
                    <b-carousel-slide
                      img-src="./img/misc/slider-MotiActiv.jpg"
                    ></b-carousel-slide>
                    <b-carousel-slide
                      img-src="./img/misc/slider-Motivation-25-Ani-15.jpg"
                    ></b-carousel-slide>
                  </b-carousel>
                </div>
          </div>
        </div>
      </div>
    </b-collapse>


  </div>
</template>

<script>
import ContactForm from "./ContactForm"
import HartaEchipe from "./HartaEchipe"
// import axios from 'axios' pentru preluare prin api a informatiei
export default {
  name: "NavBar",
  components: {
    ContactForm,
    HartaEchipe
  },
  props: {
    apiresourceurl: {type: String, required: true}
  },
  data() {
    return {
      contactform: {
        title: "Solicit contact",
        nume: "",
        telefon: "",
        website: "",
        email: "",
        msg: ""
      },
      certificareform: {
        nume: "",
        telefon: "",
        website: "",
        email: "",
        msg: ""
      },      
      contactmail: "accesibil@motivation.ro",
      allcategories: [],
      checked: [],
      subchecked: [],
      checkedaccesibil: [],
      isfilterisvisible: false,
      iscontactvisible: false,
      isdesprevisible: false,
      ismotivationvisible: false,
      currentPage: 1,
      perPage: 16,
      visible2: false,
      visible3: false,
      visible4: false,
      // apiresourceurl: "http://127.0.0.1:8000",
      // textinfo: null
    };
  },
  methods: {
    openMailTo(email, body) {
      let content = `${body.nume}\n${body.telefon}\n${body.website}\n${body.email}\n${body.msg}`
      window.open(`mailto:${email}?subject=${body.title}&body=${encodeURIComponent(content)}`);
    },
    makeResize() {
      this.visible2 = false
      this.visible3 = !this.visible3
      this.visible4 = false
      // console.log(this.visible3)
      window.dispatchEvent(new Event('resize'))
       this.$gtag.event('despre opened', { method: 'Website' })
    },
    makecolapse2() {
      this.visible2 = !this.visible2
      // console.log(this.visible2)
      this.visible3 = false
      this.visible4 = false
       this.$gtag.event('contact opened', { method: 'Website' })
    },
    makecolapse4() {
      this.visible2 = false
      this.visible3 = false
      this.visible4 = !this.visible4
       this.$gtag.event('motivation opened', { method: 'Website' })
      // console.log(this.visible4)      
    }
    // TextInfoDisplay(value) {
    //   let desc = this.textinfo.filter( item => {
    //       return   value.includes(item.nume)
    //   })
    //   // console.log(desc[0].descriere)
    //   return desc[0].descriere
    // }
  }
  // async mounted() {
  //   await axios
  //      .get(`${this.apiresourceurl}/misc/`)
  //      .then(response => (this.textinfo = Object.freeze(response.data)))      
  // }
};
</script>

<style lang="css" scoped>
@media screen and (max-width: 992px) {
  #searchbar {
    display: none;
  }
}

@media screen and (min-width: 992px) {
  #searchnavbar {
    display: none;
  }
}

.form-inline {
    flex-flow: nowrap;
    width: 450px;
}


.navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0;
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(255,255,255,.5);
}
.navbar-light .navbar-nav .nav-link:hover {
    color: #fff;
}

.custom-nav-menu2 {
  padding: 0;
}

.custom-nav-menu {
  background-color: #343a40!important;
  padding: 0.25rem 1.25rem;
}

.custom-nav-menu a {
  display: block;
}
.custom-nav-item-menu {
  margin: 5px;
}

.custom-nav-item-menu-promo {
  margin: 5px;
}

.custom-nav-item-menu-promo .nav-link {
color: #65c481 !important;
}

.custom-nav-item-menu-promo2 {
  margin: 5px;
  float: right;
}

.custom-nav-item-menu-promo2 .nav-link {
color: #7ba5d6 !important;
}

.custom-nav-item-menu-promo3 {
  margin: 5px;
}

.custom-nav-item-menu-promo3 .nav-link {
color: #dae721 !important;
}

.custom-nav-card {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header-pills {
  margin-right: 0rem;
}
.nav-link {
  color: #212529;
  font-weight: 500;
  padding: 0;
}



.custom-contact-container {
  background-color: #b8daff17;

  max-width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding-bottom: 5px;
  padding-top: 5px;
}
.custom-contact-container p {
  color: #0a2240;
  margin-bottom: 5px;
}
.custom-contact-branding p {
  padding: 0px;
  color: #123d74;
}
.custom-contact-branding {
  padding-left: 0px;
}

.custom-despre-container {
  background-color: rgb(121 123 92 / 6%);
  max-width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding-bottom: 5px;
  padding-top: 5px;
}
.custom-despre-container p {
  color: #0a2240;
  margin-bottom: 5px;
}
.custom-despre-branding p {
  padding: 0px;
  color: #123d74;
}
.custom-despre-branding {
  padding-left: 0px;
}


.custom-motivation-container {
  background-color: rgb(119 165 129 / 11%);
  max-width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding-bottom: 5px;
  padding-top: 5px;
}
.custom-motivation-container p {
  color: #0a2240;
  margin-bottom: 5px;
}
.custom-motivation-branding p {
  padding: 0px;
  color: #123d74;
}
.custom-motivation-branding {
  padding-left: 0px;
}

.custom-font-motivation-green {
  color: #2faa3b;
  font-weight: bold;
}
.custom-font-motivation-blue {
  color: #123d74;
}
.custom-filter-title {
  text-align: center;
}
.custom-close-button {
  float:right;
}
.custom-form-submit-button {
  margin: 0 auto;
  justify-content: center;
  padding: 5px;
}
</style>
